import React, { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { UwaDialog } from "@/components/UwaDialog";

export const UwaBadge = ({ compact = false }) => {
  const reduce = useReducedMotion();
  const [open, setOpen] = useState(false);
  if (compact) {
    return (
      <>
        <button onClick={() => setOpen(true)} className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-white/15 bg-white/[0.08] p-2.5 pr-5 text-left backdrop-blur-md transition-colors hover:border-[#00C3FF]/60 xl:hidden" data-testid="hero-uwa-compact">
          <img src="/uwa-badge.png" alt="UniFi Wireless Administrator" className="h-14 w-14 rounded-xl shadow-[0_0_24px_rgba(37,99,235,0.6)]" />
          <span className="block text-sm font-bold text-white">UniFi Wireless Administrator</span>
        </button>
        <UwaDialog open={open} onOpenChange={setOpen} />
      </>
    );
  }
  return (
    <div className="absolute right-24 top-1/2 z-10 hidden -translate-y-1/2 xl:block" data-testid="hero-uwa-badge">
      <motion.div
        initial={{ opacity: 0, scale: 0.8, rotate: -8 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ delay: 0.9, duration: 0.8, type: "spring", bounce: 0.35 }}
        style={{ perspective: 900 }}
      >
        <motion.div
          animate={reduce ? {} : { y: [0, -14, 0], rotateY: [-10, 10, -10], rotateX: [4, -4, 4] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          className="relative"
          style={{ transformStyle: "preserve-3d" }}
        >
          <span className="pointer-events-none absolute inset-0 -m-10 rounded-full" style={{ background: "radial-gradient(circle, rgba(37,99,235,0.55), rgba(0,195,255,0.15) 50%, transparent 72%)", filter: "blur(20px)" }} aria-hidden="true" />
          {[0, 1].map((i) => (
            <motion.span
              key={i}
              className="pointer-events-none absolute inset-0 rounded-[2rem] border border-[#00C3FF]/60"
              animate={reduce ? {} : { scale: [1, 1.35], opacity: [0.6, 0] }}
              transition={{ duration: 2.8, repeat: Infinity, delay: i * 1.4, ease: "easeOut" }}
              aria-hidden="true"
            />
          ))}
          <button
            onClick={() => setOpen(true)}
            aria-label="UniFi Wireless Administrator"
            data-testid="hero-uwa-open"
            className="relative block h-48 w-48 2xl:h-56 2xl:w-56 cursor-pointer overflow-hidden rounded-[2rem] shadow-[0_30px_60px_rgba(0,0,0,0.5)] transition-transform duration-300 hover:scale-105"
          >
            <img src="/uwa-badge.png" alt="UniFi Wireless Administrator" className="h-full w-full" />
            <span className="pt-shine pointer-events-none absolute inset-0" aria-hidden="true" />
          </button>
        </motion.div>
      </motion.div>
      <UwaDialog open={open} onOpenChange={setOpen} />
    </div>
  );
};
